import RefreshIcon from '../../assets/svg/RefreshIcon';
import { Button, Icon, Loader } from '../../components/Shared';
import { useSalesforceContext } from '../../hooks';
import { Layout } from '../../layouts';

const STATE = {
  HAS_DATA: 'hasData',
  IS_DATA_LOADING: 'isDataLoading',
  IS_DATA_ERROR: 'isDataError',
};

const getState = (isDataLoading, isDataError) => {
  if (isDataLoading) return STATE.IS_DATA_LOADING;
  if (isDataError) return STATE.IS_DATA_ERROR;
  return STATE.HAS_DATA;
};

export const Settings = () => {
  const {
    connectSalesforce,
    disconnectSalesforce,
    isSalesforceLoading,
    isSalesforceError,
    isSalesforceDisconnecting,
    isSalesforceAvailable,
    refetchSalesforce,
    isSalesforceConnecting,
  } = useSalesforceContext();

  const state = getState(isSalesforceLoading, isSalesforceError);

  return (
    <Layout>
      {state === STATE.IS_DATA_LOADING && (
        <div className="h-full flex justify-center items-center">
          <Loader />
        </div>
      )}

      {state === STATE.IS_DATA_ERROR && (
        <div className="h-full flex justify-center items-center flex-col gap-3 bg-brand-300/[0.08] rounded-[20px]">
          <div className="flex justify-center items-center flex-col gap-1.5">
            <span className="text-base-1000 text-[22px]/[28px] font-semibold">
              Failed to load data
            </span>
            <span className="text-base-800 text-[16px]/[24px]">
              Error occurred while loading. Try again.
            </span>
          </div>
          <Button
            title="Reload"
            variant="text"
            className="text-destructive-500 !bg-transparent"
            iconStart={<RefreshIcon className="w-5 h-5 text-destructive-500" />}
            onClick={refetchSalesforce}
          />
        </div>
      )}

      {state === STATE.HAS_DATA && (
        <div className="flex flex-col gap-4">
          <h1 className="text-base-1000 text-[22px]/[28px] font-semibold py-2.5">
            Settings
          </h1>
          <h2 className="text-base-1000 text-[18px]/[24px] font-semibold">
            Integrations
          </h2>
          <div className="max-w-[386px] w-full bg-white rounded-xl">
            <div className="p-3 flex gap-3">
              <div className="shrink-0 w-12 h-12 flex items-center justify-center border border-base-200 rounded-sm">
                <Icon name="salesforce" alt="Salesforce" />
              </div>
              <div className="flex flex-col gap-1">
                <p className="text-base-1000 text-[18px]/[24px] font-medium">
                  Salesforce
                </p>
                <p className="text-base-800 text-[16px]/[24px]">
                  Export reports directly to your Salesforce account with one
                  click.
                </p>
              </div>
            </div>
            <div className="p-3 border-t border-t-base-200">
              {isSalesforceAvailable ? (
                <Button
                  title="Disconnect"
                  variant="text"
                  className="text-destructive-500 ml-auto !bg-transparent"
                  onClick={disconnectSalesforce}
                  disabled={isSalesforceDisconnecting}
                />
              ) : (
                <Button
                  title="Connect"
                  className="ml-auto"
                  onClick={connectSalesforce}
                  disabled={isSalesforceConnecting}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};
